export const HOMAPGE_API = {
    GET_RESEARCH_NEWS_UPDATES: 'research/getResearchNewsUpdates',
    GET_RESEARCH_EXPERT_OPINIONS: 'research/getResearchExpertOpinions',
    ALL_CATEGORIES_BOOK:  'BookStoreCustomProducts/getHomePageTopLatestProducts',
	LATEST_RELEASES: "/home/list/latestReleases",
	NEW_BOOKS_BY_COLLECTION_TAG_ID: "/product/getCollectionByTagId",
    LATEST_PAST_ZOOM_WEBINARS:'webinar/zoom_getupcombinedwebinarlist',
    LATEST_PAST_ZOOM_LEARNING:'home/events/upcoming',
    LATEST_BUDGET_HIGHLIGHT:'budget/getStoriesNew'
}
